<template>
  <div>
    <div v-if="!dict">
      <div class="my-code">点击字典查看详情</div>
    </div>
    <div v-else>
      <!--工具栏-->
      <div class="head-container">
        <!-- 搜索-->
        <dynamic-search
            :data="tableFilterList(tableHead)"
            @search="dataTableSearch">
        </dynamic-search>
      </div>
      <!--表单组件-->
      <eForm ref="form" :is-add="isAdd" :dict-id="dict.id"/>
      <!--表格渲染-->
      <edit-data-table
      :head="tableHead"
      :data.sync="list"
      :config="{trigger: 'click', mode: 'cell'}"
      :total="total"
      :offset="offset"
      :page="page"
      :loading="loading"
      @handlePageChange="dataTablePageChange"
      @handleSizeChange="dataTableSizeChange"
      >
        <template #toolbar="scope">
          <el-button type="text" size="mini" icon="el-icon-edit" @click="edit(scope.row)"></el-button>
          <el-popover :ref="scope.row.id" placement="top" width="180">
              <p>确定删除本条数据吗？</p>
              <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
                  <el-button :loading="delLoading" type="primary" size="mini" @click="subDelete(scope.row.id)">确定</el-button>
              </div>
              <el-button type="text" size="mini" icon="el-icon-delete" slot="reference" class="table-del-btn"></el-button>
          </el-popover>
        </template>
        <template #dicName>
            {{dict.name}}
        </template>
      </edit-data-table>
    </div>
  </div>
</template>

<script>
import "@/components/EditDataTable"
import DynamicSearch from '@/components/DynamicSearch'
import DataTableMixin from '@/mixins/DataTableMixin'
import eForm from './form'
import { del } from '@/api/dictDetail'
import { deepClone } from '@/utils/index'
export default {
  components: { DynamicSearch, eForm },
  mixins: [DataTableMixin],
  data() {
    return {
      delLoading: false,
      isAdd: false,
      dict: null,
      tableHead: [
        {
          label: '字典标签',
          prop: 'label',
          query: {
              type: 'input'
          },
          // sortable: true,
        },
        {
          label: '字典值',
          prop: 'value'
        },
        {
          label: '所属字典',
          prop: 'dicName',
        }
      ]
    }
  },
  methods: {
     dataTableBeforeInit() {
        this._url = '/dict-detail'
        const params = { current: this.page, size: this.offset, code: this.dict.code }
        this._params = Object.assign(params,this._query)
        return true
    },
    subDelete(id) {
        this.delLoading = true
        del(id).then(res => {
            this.delLoading = false
            this.$refs[id].doClose()
            this.dleTableChangePage()
            this.dataTableInit()
            this.$notify({
                title: '删除成功',
                type: 'success',
                duration: 2500
            })
        }).catch(err => {
            this.delLoading = false
            this.$refs[id].doClose()
            console.log(err)
        })
    },
    edit(data) {
      this.isAdd = false
      const _this = this.$refs.form
      _this.form = deepClone(data)
      _this.dialog = true
    }
  }
}
</script>

<style scoped>

</style>
